/*
 * Extract dominant color from variant image using histogram-based mode
 * (quantize into bins, take the largest non-background bin).
 *
 * Only runs on swatches marked data-extract-color="true" (compound names like
 * strap variants). Simple variant names like "Zwart" or "Goud" (watches) keep
 * their Liquid hex mapping.
 *
 * Debug: add ?swatchdebug to URL to enable console logging.
 */
(function () {
  var SWATCH_SEL = '.color-swatchimg[data-variant-image][data-extract-color="true"]';
  var CACHE = {};
  var DEBUG = window.location.search.indexOf('swatchdebug') !== -1;

  function log() {
    if (DEBUG) console.log.apply(console, ['[swatch-color]'].concat([].slice.call(arguments)));
  }

  function toHex(v) { return ('0' + Math.max(0, Math.min(255, v | 0)).toString(16)).slice(-2); }
  function rgbToHex(r, g, b) { return '#' + toHex(r) + toHex(g) + toHex(b); }

  /** Histogram mode: quantize pixels to buckets, return largest non-white bucket's averaged color. */
  function dominantColorFromData(data) {
    var bins = {};
    // Quantize: 5 bits per channel -> 32 levels (32^3 = 32768 bins max; practical far fewer populated)
    for (var i = 0; i < data.length; i += 4) {
      var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
      if (a < 100) continue;
      // Skip near-white (background)
      if (r > 240 && g > 240 && b > 240) continue;
      // Skip near-transparent gray (very light watermark text)
      var max = Math.max(r, g, b), min = Math.min(r, g, b);
      if (max > 220 && (max - min) < 10) continue;
      var rQ = r >> 3, gQ = g >> 3, bQ = b >> 3;
      var key = rQ + '-' + gQ + '-' + bQ;
      if (!bins[key]) bins[key] = { count: 0, r: 0, g: 0, b: 0 };
      bins[key].count++;
      bins[key].r += r;
      bins[key].g += g;
      bins[key].b += b;
    }
    var best = null;
    for (var key in bins) {
      if (!bins.hasOwnProperty(key)) continue;
      if (!best || bins[key].count > best.count) best = bins[key];
    }
    if (!best || best.count === 0) return null;
    return {
      r: Math.round(best.r / best.count),
      g: Math.round(best.g / best.count),
      b: Math.round(best.b / best.count),
      count: best.count
    };
  }

  function extractColor(imageUrl, cb) {
    if (!imageUrl) { cb(null); return; }
    if (CACHE[imageUrl] !== undefined) { cb(CACHE[imageUrl]); return; }
    var normalizedUrl = imageUrl.indexOf('//') === 0 ? 'https:' + imageUrl : imageUrl;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var size = 100;
        var canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, size, size);
        // Sample center 50% — tighter focus on the strap material, less buckle/background.
        var start = Math.floor(size * 0.25);
        var region = Math.floor(size * 0.5);
        var data = ctx.getImageData(start, start, region, region).data;
        var dominant = dominantColorFromData(data);
        if (!dominant) {
          log('no dominant color for', imageUrl);
          CACHE[imageUrl] = null; cb(null); return;
        }
        var hex = rgbToHex(dominant.r, dominant.g, dominant.b);
        log('extracted', hex, '(bucket size', dominant.count, 'px) from', imageUrl);
        CACHE[imageUrl] = hex;
        cb(hex);
      } catch (e) {
        log('canvas error', imageUrl, e && e.message);
        CACHE[imageUrl] = null; cb(null);
      }
    };
    img.onerror = function () {
      log('image load error', imageUrl);
      CACHE[imageUrl] = null; cb(null);
    };
    img.src = normalizedUrl;
  }

  function applyToSwatch(swatch) {
    if (swatch.__bmsColorExtracted) return;
    swatch.__bmsColorExtracted = true;
    var url = swatch.getAttribute('data-variant-image');
    if (!url) return;
    extractColor(url, function (color) {
      if (!color) return;
      swatch.style.backgroundColor = color;
    });
  }

  function initAll(root) {
    var nodes = (root || document).querySelectorAll(SWATCH_SEL);
    log('initAll — found', nodes.length, 'compound-name swatches');
    nodes.forEach(applyToSwatch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  try {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SWATCH_SEL)) applyToSwatch(node);
          if (node.querySelectorAll) initAll(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (e) { }
})();
